import { FDBodyText, FDHeadlineText } from '@facet-wealth/design';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { DialogTitle } from 'Views/Page/Content/Modal/Components';
import ExpensesReducibilitySlider
  from 'Views/Page/Content/Modal/Layouts/ExpensesReducibleByStep/Layout/ExpensesReducibilitySlider';

export default buildFacetDesignOverride()
  .nameOverride('explainer1', {
    _component: () => DialogTitle,
    _customProps: {
      size: 'lg',
    },
    ordinal: 100,
  }, overrideReadOnly)
  .nameOverride('explainer2', {
    _component: () => FDBodyText,
    _customProps: {
      size: 'lg',
    },
    ordinal: 100,
  }, overrideReadOnly)
  .nameOverride('instructions', {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'sm',
    },
    ordinal: 100,
  }, overrideReadOnly)
  .nameOverride('instructionSubtext', {
    _component: () => FDBodyText,
  }, overrideReadOnly)
  .nameOverride('infoText', {
    hidden: true,
  }, overrideReadOnly)
  .nameOverride('expensesReducibilityPercentage', {
    _component: () => ExpensesReducibilitySlider,
    ordinal: 200,
  }, overrideReadOnly);
